import * as React from "react";
import LedgerCardSettingsList from "./LedgerCardSettingsList";

const LedgerCardSettings = () => {
  return (
    <div className="d-flex flex-column h-100 w-100 settings-container-sm pt-4">
      <div className="flex-grow-1" style={{ minHeight: 0 }}>
        <LedgerCardSettingsList />
      </div>
    </div>
  );
};

export default LedgerCardSettings;
